import { optionUrlCustomSchema } from "@/libs/zod-errors";

/**
 * Normalizes a link extracted by an importer (CV analyzer, LinkedIn scraper)
 * before it lands in the onboarding store.
 *
 * The CV analyzer is prompted for raw URLs and happily returns protocol-less
 * values ("portfolio.andreafabbri.design") or plain text when the CV has none,
 * so everything goes through the same schema the online-presence forms use:
 * valid links get the `https://` prefix, anything else is dropped instead of
 * being persisted to the profile.
 */
export const toStoredUrl = (value: string | null | undefined): string => {
  if (!value) return "";
  const parsed = optionUrlCustomSchema.safeParse(value.trim());
  return parsed.success ? (parsed.data ?? "") : "";
};
